import { css } from '@fable/theme'
import { StatsUpsellCard } from './StatsUpsellCard'
import { analytics } from 'segment_analytics'
import { useStatsTheme } from '../../theme/ctx'

export const StatsPlusUpsell = () => {
  const theme = useStatsTheme((s) => s.theme)
  const description =
    'Get more out of your reading data with deeper insights and more granular goal tracking'

  return (
    <StatsUpsellCard
      description={description}
      title="Unlock more charts"
      textFluidWidth="40%"
      onClick={() => analytics.events.stats.statsSubUpsell('goals')}
      imageEl={
        <div
          className={css`
            padding: 0 20px;
            display: block;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
          `}
        >
          <img
            className={css`
              display: block;
              object-fit: contain;
              object-position: center right;
              width: 60%;
              max-width: 280px;
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
            `}
            src={theme.colors.upsell}
            alt="fable-plus-upsell-goal"
          />
        </div>
      }
    />
  )
}
